require('./loansBlockedAccountsMessage.scss');
//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@component
const WizardError = require('components/commons/wizardError/wizardError');
//@core
const { formatText, FormattedText } = require('core/i18n').i18n;

const LoansBlockedAccountsMessage = (props) => {
    const errorMessage = formatText('loansBlockedAccountsMessage-loansBlockedAccountsMessage_errorMessage');
    const mainButtonLabel = formatText('loansBlockedAccountsMessage-loansBlockedAccountsMessage_redirect');
    const mainButton = {
        url: props.backUrl || '/myprofile/loans-mortgages',
        label: props.backLabel || mainButtonLabel.toUpperCase()
    };

    return (
        <div className="col-xs-12">
            <WizardError
                errorMessage={errorMessage}
                mainButton={mainButton}
            >
                <FormattedText
                    value="loansBlockedAccountsMessage-loansBlockedAccountsMessage_moreInfo"
                    className="loans-bloked-accounts-message__message"
                />
            </WizardError>
        </div>
    );
};

LoansBlockedAccountsMessage.propTypes = {
    backLabel: PropTypes.string,
    backUrl: PropTypes.string
}

module.exports = LoansBlockedAccountsMessage;
